import { useNavigate } from "react-router-dom";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";
import { ServiceGrid, UrgentCallout } from "@/pages/Home";
import { IMG } from "@/lib/constants";
import { useSeo } from "@/lib/seo";

export function PageHead({ title, intro, img }) {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8 grid md:grid-cols-[1.4fr_1fr] gap-10 items-end">
      <div className="fade-up">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
        {intro && <p className="mt-5 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">{intro}</p>}
      </div>
      {img && <img src={img} alt={title} className="hidden md:block h-56 w-full object-cover rounded-3xl" />}
    </section>
  );
}

export default function Services() {
  const { t } = useI18n();
  const nav = useNavigate();
  useSeo(t("services.title"), t("services.intro"));
  return (
    <div data-testid="services-page">
      <PageHead title={t("services.title")} intro={t("services.intro")} img={IMG.ac} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10">
        <ServiceGrid />
        <div className="mt-8 flex items-start gap-3 rounded-2xl bg-teal-50 border border-teal-100 p-5 text-sm text-teal-900">
          <Info className="h-5 w-5 shrink-0" />{t("services.note")}
        </div>
        <div className="mt-8"><UrgentCallout /></div>
        <Button size="lg" onClick={() => nav("/request")} className="mt-10 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold" data-testid="services-cta-btn">{t("services.cta")}</Button>
      </section>
    </div>
  );
}
